import React, { useState } from 'react'
import act from './act.module.css'
import { MdOutlineDashboard } from 'react-icons/md'
import { LuFileSliders } from 'react-icons/lu'
import { CiSearch, CiSettings } from 'react-icons/ci'
import imgI from '../../../../img/img25.png'
import imgi from '../../../../img/img10.png'
import imgii from '../../../../img/img7.png'
import { Link } from 'react-router'

const ActicleR = () => {

    const [Search, setSearch] = useState('')


  return (
    <div className={act.act}>
        <div className={act.container}>
            <div className={act.content}>
                <div className={act.block}>
                    <div className={act.blocki}>
                        <div className={act.seci}>
                            <div className={act.icon}>
                                <MdOutlineDashboard className={act.word}  size={'1rem'} />
                                
                                <h3 className={act.word}>Dashboard</h3>
                            </div>
                            <div className={act.icon}>
                                <LuFileSliders className={act.wordi} size={'1rem'}/>
                                <h3>Article Review</h3>
                            </div>
                        </div>
                        <div className={act.seciI}>
                            <div className={act.icon}>
                                <CiSettings className={act.wordi} size={'1rem'}/>
                                <h3>Settings</h3>
                            </div>
                            <div className={act.icon}>                               
                                <h3>Logout</h3>
                            </div>
                        </div>
                    </div>
                    <div className={act.blockI}>
                    <div className={act.blockii}>
                        <div className={act.dash}>
                            <h2>Dashboard</h2>
                            <div className={act.dashi}>
                                <input 
                                type="search" 
                                name="search" id="search" 
                                placeholder='Search for article'
                                onChange={(e)=> setSearch(e.target.value)}/>
                                <CiSearch />

                            </div>
                        </div>
                    </div>
                    <div className={act.blockiii}>
                        <div className={act.card}>
                            <div className={act.secii}>
                                <h4>Total Reviews</h4>
                                <button>6 Months</button>
                            </div>
                            <h2>450</h2>
                            <p>Total articles reviewed from the past months, the metrics
                            is based on your total review you have done.</p>
                        </div>
                        <div className={act.card}>
                            <div className={act.secii}>
                                <h4>Pending Review</h4>
                                <button>6 Months</button>
                            </div>
                            <h2>70</h2>
                            <p>Total articles reviewed from the past months, the metrics
                            is based on your total review you have done.</p>
                        </div>
                        <div className={act.card}>
                            <div className={act.secii}>
                                <h4>Declined Articles</h4>
                                <button>6 Months</button>
                            </div>
                            <h2>40</h2>
                            <p>Total articles reviewed from the past months, the metrics
                            is based on your total review you have done.</p>
                        </div>
                    </div>
                    <div className={act.blockiv}>
                        <div className={act.seciii}>
                            <h3>Articles</h3>
                            <Link to='/ReviewerII/ReviewerIII'> <button>See all</button></Link>
                        </div>
                        <div className={act.flexi}>
                            <div className={act.cardi}>
                                <img src={imgI}className={act.imgi} alt="" />
                                <button  className={act.btni}>Reviewed</button>
                                <h4>
                                Labour Building project in Nigeria invested 
                                $13million in the project for 2030
                                </h4>
                                <p>
                                Labour congress has been seen to have invested a huge sum 
                                of money worth $13 million for a build up project, proclaimed 
                                by the Labour president Mr Lamidi has told one of our 
                                representative that...
                                </p>
                                <button  className={act.btnii}>View</button>
                            </div>
                            <div className={act.cardi}>
                                <img src={imgi} alt="" />
                                <button  className={act.btni}>Reviewed</button>
                                <h4>
                                Labour Building project in Nigeria invested 
                                $13million in the project for 2030
                                </h4>
                                <p>
                                Labour congress has been seen to have invested a huge sum 
                                of money worth $13 million for a build up project, proclaimed 
                                by the Labour president Mr Lamidi has told one of our 
                                representative that...
                                </p>
                                <button   className={act.btnii}>View</button>
                            </div>
                            <div className={act.cardi}>
                                <img src={imgii} alt="" />
                                <button className={act.btni}>Reviewed</button>
                                <h4>
                                Labour Building project in Nigeria invested 
                                $13million in the project for 2030
                                </h4>
                                <p>
                                Labour congress has been seen to have invested a huge sum 
                                of money worth $13 million for a build up project, proclaimed 
                                by the Labour president Mr Lamidi has told one of our 
                                representative that...
                                </p>
                                <button   className={act.btnii}>View</button>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ActicleR
